import {Route, Switch, Link} from "react-router-dom";
import {ProtectedRoute} from "./screens/auth/auth-screen";
import React from "react";
import {UploadNewReceipt} from "./screens/receipts/upload-new-receipt";
import {UploadNewFindoc} from "./screens/findoc/upload-new-findoc";
import ReceiptsDetailsScreen from "./screens/receipts/receipts-details-screen";
import FindocDetailsScreen from "./screens/findoc/findoc-details-screen";
import {BucketsScreen} from "./screens/buckets/buckets-screen";
import {BucketDetailScreen} from "./screens/buckets/bucket-detail-screen";
import SearchScreen from "./screens/search/search-screen";
import ProjectDashboardScreen from "./screens/projects/project-dashboard-screen";
import PricingPlans from "./screens/payments/payments-pricing-plans";
import PaymentSuccess from "./screens/payments/payment-success";
import FaqScreen from "./screens/faq/faqScreen";

export function Routes() {
    return <Switch>
        <Route exact path='/faq' component={FaqScreen} />
        <Route exact path='/payment/success' component={PaymentSuccess} />
        <Route exact path='/payment/canceled' component={PaymentSuccess} />

        <ProtectedRoute exact path='/' component={BucketsScreen} />
        <ProtectedRoute exact path='/projects' component={BucketsScreen} />
        <ProtectedRoute exact path='/projects/:bucketName' component={BucketDetailScreen} />
        <ProtectedRoute exact path='/projects/:projectId/dashboard' component={ProjectDashboardScreen} />
        <ProtectedRoute exact path='/search' component={SearchScreen} />

        <ProtectedRoute exact path='/upload-receipt' component={UploadNewReceipt} />
        <ProtectedRoute exact path='/upload-findoc' component={UploadNewFindoc} />

        <ProtectedRoute exact path='/receipts/:receiptId' component={ReceiptsDetailsScreen} />
        <ProtectedRoute exact path='/findocs/:findocId' component={FindocDetailsScreen} />

        <ProtectedRoute exact path='/billing' component={PricingPlans} />

        <Route path="*">
            <div style={{textAlign: 'center', padding: '60px 20px'}}>
                <h3>
                    Couldn't find <code>{window.location.pathname}</code>
                    <br/>
                    <Link to="/projects">Go to Projects</Link>
                </h3>
            </div>
        </Route>
    </Switch>
}
